module.exports = "/assets/9849920f973a567168be7b2d322f83e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/SU.png
// module id = 2955
// module chunks = 0